import React from 'react';
import PropTypes from 'prop-types';
import HelpIcon from '@material-ui/icons/Help';
import MuiTooltip from '../../../../atoms/MuiTooltip';

/**
 * 元位置建替有無のツールチップ。
 * 通常は値変更時に起こる自動追加/自動削除の説明を表示し、
 * disabled時(「有(元戻し)」を選択していて変更できない場合)は
 * 変更できない理由を表示する。一覧のヘッダ部分と電柱情報入力ダイアログの
 * 項目部分で表示内容を揃えるため、共通コンポーネントとして切り出している
 * @param {object} props
 * @param {boolean} props.disabled 変更不可の理由を表示する場合true
 * @return {JSX.Element}
 */
const OnSiteRebuildTooltip = ({disabled}) => (
  <MuiTooltip content={
    disabled ? (
      <React.Fragment>
        「有(元戻し)」の項目が選択されているため、変更できません。<br />
        削除するには「有(仮移設)」を「無」に変更してください。
      </React.Fragment>
    ) : (
      <React.Fragment>
        ・「有(仮移設)」を設定すると、「有(元戻し)」が自動で追加されます。<br />
        ・「有(仮移設)」を「無」に変更すると、「有(元戻し)」が自動で削除されます。<br />
        ・「有（元戻し）」のみを削除することはできません。
      </React.Fragment>
    )
  }>
    <HelpIcon fontSize="small" />
  </MuiTooltip>
);

OnSiteRebuildTooltip.propTypes = {
  disabled: PropTypes.bool,
};

export default OnSiteRebuildTooltip;
